module.exports = __webpack_public_path__ + "4273000c3e1281a8ad57caf2fa14301d.png";